// extracted by mini-css-extract-plugin
export var dateLabel = "_36-0";
export var dateLabelError = "_36-1";
export var fullWidth = "_36-2";
export var smaller = "_36-3";